var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "text-black-900 w-24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.44 21.26l-1.233-4.954-3.888-14.873a1.278 1.278 0 00-.572-.779 1.193 1.193 0 00-.934-.132l-4.776 1.283a1.239 1.239 0 00-.408-.31 1.195 1.195 0 00-.493-.113H1.795a1.21 1.21 0 00-.873.376 1.31 1.31 0 00-.361.907v20.532c0 .34.13.667.361.907.231.24.545.376.873.376h12.341c.328 0 .642-.135.873-.376a1.31 1.31 0 00.361-.907V12.93l2.716 10.548c.072.28.233.526.457.699.224.172.498.26.777.25.106.013.214.013.32 0l5.962-1.655c.157-.043.305-.12.434-.223.13-.103.237-.232.318-.38.13-.284.161-.606.087-.91zm-19.746.705H2.992v-2.567h3.702v2.567zm0-5.133H2.992v-7.7h3.702v7.7zm0-10.266H2.992V4h3.702v2.566zm6.171 15.399H9.163v-2.567h3.702v2.567zm0-5.133H9.163v-7.7h3.702v7.7zm0-10.266H9.163V4h3.702v2.566zm2.777-2.233l3.579-1 .642 2.476-3.58 1-.641-2.476zm3.196 12.396l-1.913-7.442 3.58-1.001 1.912 7.442-3.579 1.001zm1.235 4.954l-.642-2.477 3.579-1 .642 2.476-3.58 1z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.46875714e422fe449f415f93b6928cae.svg";
export { ForwardRef as ReactComponent };